/**
 * Created by olga on 31.07.2025
 */

Map2d.SMILE = true;